import script from "./cancel-pay-return.vue?vue&type=script&lang=ts&setup=true"
export * from "./cancel-pay-return.vue?vue&type=script&lang=ts&setup=true"

import "./cancel-pay-return.vue?vue&type=style&index=0&id=2f7c70db&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7c70db"]])

export default __exports__